export default "__VITE_ASSET__DKkUqE0M__"